export const isServerError = (statusCode: number) => statusCode >= 500
